
import React from 'react';
import TimeRangeSelector from './TimeRangeSelector';
import DataStatusIndicator from './DataStatusIndicator';
import RefreshDataButton from './RefreshDataButton';

interface DataControlsProps {
  timeRange: string;
  setTimeRange: (value: string) => void;
  timeRanges: Record<string, { label: string; days: number }>;
  useMockData: boolean;
  handleRefresh: () => void;
  isRefreshing: boolean;
}

const DataControls: React.FC<DataControlsProps> = ({
  timeRange,
  setTimeRange,
  timeRanges,
  useMockData,
  handleRefresh,
  isRefreshing
}) => {
  return (
    <div className="flex flex-col space-y-3 sm:space-y-0 sm:flex-row sm:items-center sm:justify-between sm:gap-4 mb-6">
      <TimeRangeSelector 
        timeRange={timeRange} 
        setTimeRange={setTimeRange} 
        timeRanges={timeRanges} 
      />
      
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        {useMockData && <DataStatusIndicator useMockData={useMockData} isSimpleLabel={true} />}
        <RefreshDataButton onClick={handleRefresh} isRefreshing={isRefreshing} />
      </div>
    </div>
  );
};

export default DataControls;
